module.exports = __webpack_public_path__ + "img/img4.8fdfb6d8.svg";